export const quote =
	() => `<svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.27778 2.66667V1.2854C4.27778 0.829397 3.71733 0.611393 3.4092 0.947539L0.309707 4.3288C0.134476 4.51997 0.134477 4.81337 0.309707 5.00453L3.4092 8.3858C3.71733 8.72194 4.27778 8.50394 4.27778 8.04793V6.6C6.36702 6.6 8.02771 7.09869 9.35751 8.15999C9.7839 8.50029 10.5285 8.12738 10.3256 7.62099C9.36002 5.21131 7.52177 3.17222 4.27778 2.66667Z" fill="#403F42"/>
    </svg>    
`;
